import {
  CHANGE_PASSWORD_REQUEST,
  FORCE_LOGOUT_REQUEST,
  IS_USER_FORCED_LOGOUT_REQUEST,
  IS_USER_FORCED_LOGOUT_RESPONSE,
  LOGIN_REQUEST,
  LOGIN_RESPONSE,
  LOGOUT_REQUEST,
  RESET_PASSWORD_REQUEST
} from "./types";

export const loginRequest = (payload) => ({
  type: LOGIN_REQUEST,
  payload
});

export const loginResponse = (payload) => ({
  type: LOGIN_RESPONSE,
  payload
});

export const logoutRequest = (payload) => ({
  type: LOGOUT_REQUEST,
  payload
});

export const changePasswordRequest = (payload) => ({
  type: CHANGE_PASSWORD_REQUEST,
  payload
});

export const resetPasswordRequest = (payload) => ({
  type: RESET_PASSWORD_REQUEST,
  payload
});

export const isUserForcedLogoutRequest = (payload) => ({
  type: IS_USER_FORCED_LOGOUT_REQUEST,
  payload
});

export const isUserForcedLogoutResponse = (payload) => ({
  type: IS_USER_FORCED_LOGOUT_RESPONSE,
  payload
});

export const forceLogoutRequest = (payload) => ({
  type: FORCE_LOGOUT_REQUEST,
  payload
});
